export const iconFontAwesomeMapsBellSlash = (
	<i className="fa-solid fa-bell-slash"></i>
);
